import { FC } from 'react';
import { FacetFiltersProps, Styled, FacetFilter } from './';
import { useI18n } from 'contexts/i18n';

const FacetFilters: FC<FacetFiltersProps> = ({
  facetFilters,
  onChange,
  appliedFacetFilters,
  translations,
}) => {
  const i18n = useI18n();

  const shouldDisplayFacetFilters =
    facetFilters &&
    facetFilters.length > 0 &&
    facetFilters.some(facetFilter => {
      return facetFilter.values && facetFilter.values.length > 1;
    });
  return (
    <>
      {shouldDisplayFacetFilters && (
        <Styled.FacetFiltersContainer>
          <Styled.FilterHeadingWrapper>
            <Styled.FilterHeading>{i18n['Filters']}</Styled.FilterHeading>
          </Styled.FilterHeadingWrapper>
          {facetFilters.map(facetFilter => {
            return (
              <FacetFilter
                key={facetFilter.name}
                facetFilter={facetFilter}
                onChange={onChange}
                appliedFacetFilters={appliedFacetFilters}
                translations={translations}
              />
            );
          })}
        </Styled.FacetFiltersContainer>
      )}
    </>
  );
};

export default FacetFilters;
